export const MAX_ZOOMING_SCALE = 3.5;
